// The Item Search island's gate on the item just requested from it (#798) —
// the donor's `LastRequestedItem` condition
// (`ItemSearchIsland/components/LastRequestedItem.tsx:14-19`), shared by the
// gate component (`components/catalog/last-requested-item.tsx`) and the island
// host that composes the grid's item order.

export interface LastRequestedItemGate {
  /**
   * The search has settled — the donor's `allResultsLoaded`, which is "not
   * fetching and not failed", not "every page has arrived". So the card can
   * show after any page and duplicate an item a later page would bring.
   */
  allResultsLoaded: boolean;
  /** The item the last successful request created, or `null` before one. */
  requestedItemId: number | null;
  /** The active selection's item, pinned first by the host, or `null`. */
  activeItemId: number | null;
  /** The ids the results grid already draws. */
  resultItemIds: readonly number[];
}

/** Whether the requested item's card is appended — the donor's four arms, in its order. */
export function showsLastRequestedItem({
  allResultsLoaded,
  requestedItemId,
  activeItemId,
  resultItemIds,
}: LastRequestedItemGate): boolean {
  return (
    allResultsLoaded &&
    requestedItemId !== null &&
    requestedItemId !== activeItemId &&
    !resultItemIds.includes(requestedItemId)
  );
}
